import { getPaletteColor } from 'pcln-design-system'
import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  body {
  background-color: ${getPaletteColor('background.lightest')};
  margin: 0;
  padding: 0;

  &.mobile-menu-activated {
    .app-banner {
      position: relative;
      width: 98vw;
    }
  }
}
`
